import { render, staticRenderFns } from "./CombinationReportClassic.vue?vue&type=template&id=5eb47e82&scoped=true"
import script from "./CombinationReportClassic.vue?vue&type=script&lang=js"
export * from "./CombinationReportClassic.vue?vue&type=script&lang=js"
import style0 from "./CombinationReportClassic.vue?vue&type=style&index=0&id=5eb47e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb47e82",
  null
  
)

/* custom blocks */
import block0 from "./CombinationReportClassic.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports